export default __webpack_public_path__ + "static/media/arrowDown.ebb52547.svg";